export const updateSettings = (data) => ({
	type: 'UPDATE_SETTINGS',
	payload: data,
});

export const deleteTab = (tab) => ({
	type: 'DELETE_TAB',
	id: tab,
});

export const addTab = (tab) => ({
	type: 'ADD_TAB',
	id: tab,
});

export const changeTab = (data) => ({
  type: 'CHANGE_TAB',
  payload: data,
});



// WEBPACK FOOTER //
// ./src/store/actions/index.js